import {Bookobject} from '../book/bookobject';
import {ErrorObject} from './error';

export class FileEndPointObject {
    constructor(public data?: Bookobject, public error?: ErrorObject) {
    }
}
